export default function Logo() {
    
    return <img src="assets/img/logo.png" alt=""/>
}